const relacao_de_alunos_incluidos = [
  {
    path: "/relacao-de-alunos-incluidos",
    redirect: "/relacao-de-alunos-incluidos",
    meta: {
      breadCrumb: "Gestão - Informação Complementar do Aluno",
    },
    children: [
      {
        path: "/relacao-de-alunos-incluidos",
        name: "relacao-de-alunos-incluidos",
        component: () =>
          import(
            "@/views/RelacaoDeAlunosIncluidos/RelacaoDeAlunosIncluidos.vue"
          ),
      },
    ],
  },
];

export { relacao_de_alunos_incluidos };
